import { useEffect, useState } from "react";
import { useBQMQ } from "context/BQMQ.context";
import VotingCell from "./VotingCell/VotingCell";
import VotingRowContainer from "./VotingRow.styles";
import queryString from "query-string";

type Props = {
    question: string;
    questionID: string;
    agree?: boolean;
    disabled?: boolean;
    updateSectionCompletionStatus: () => void;
};

export default function VotingRow({
    question,
    questionID,
    agree = false,
    disabled = false,
    updateSectionCompletionStatus,
}: Props) {
    const [numberSelected, setNumberSelected] = useState<
        number | string | null
    >(null);
    const { myVotes, setMyVotes } = useBQMQ();
    const [userId, setUserId] = useState<string>("");
    const formattedQuestion = question === "Fade" ? "Fade" : `${question}*`;
    const [initialRender, setInitialRender] = useState<boolean>(true);
    const sessionId = queryString.parse(window.location.search).session_id;

    useEffect(() => {
        if (numberSelected !== null) {
            setMyVotes((prevVotes: any) => {
                const updatedVotes = {
                    ...prevVotes,
                    [questionID]: numberSelected,
                };
                if (userId)
                    localStorage.setItem(
                        `myVotes ${userId} ${sessionId}`,
                        JSON.stringify(updatedVotes)
                    );
                return updatedVotes;
            });
        }
    }, [numberSelected]);

    useEffect(() => {
        if (initialRender) {
            setInitialRender(false);
            const userId = localStorage.getItem("gim-user-id") || "";
            setUserId(userId);
            return;
        }
        if (myVotes[questionID] !== numberSelected) {
            setNumberSelected(myVotes[questionID]);
        }
    }, [myVotes, questionID]);

    const handleSelectOption = (selected?: string) => {
        if (!disabled) {
            setNumberSelected(selected ?? null);
            updateSectionCompletionStatus();
        }
    };

    return (
        <VotingRowContainer key={questionID}>
            <div className="questionCell">
                {formattedQuestion === "MQ**" ? "MQ*" : formattedQuestion}
            </div>

            {!agree && (
                <div className="votingCells">
                    {["1", "2", "3", "4", "5"].map((number) => (
                        <VotingCell
                            key={number}
                            number={number}
                            selected={myVotes[questionID]}
                            setSelected={handleSelectOption}
                            disabled={disabled}
                            tooltip={
                                disabled
                                    ? "Only the selected section is editable for this session"
                                    : undefined
                            }
                        />
                    ))}
                </div>
            )}

            {agree && (
                <>
                    {["AGREE", "NEUTRAL", "DISAGREE"].map((title) => (
                        <VotingCell
                            key={title}
                            number={title}
                            selected={myVotes[questionID]}
                            setSelected={handleSelectOption}
                            disabled={disabled}
                            tooltip={
                                disabled
                                    ? "Only the selected section is editable for this session"
                                    : undefined
                            }
                        />
                    ))}
                </>
            )}
        </VotingRowContainer>
    );
}
